import { History } from 'history'
type LocationState = History.LocationState

const routePushHandler = (history: History<LocationState>, path: string) => () =>
  history.push(path);

export default routePushHandler;
